const React = require("react"),
    PropTypes = require('prop-types'),
    linkUtil = require("linkUtil");
const {Row, Col, Panel,  ButtonGroup, ListGroupItem, ListGroup, Alert} = require("react-bootstrap");

const LoadingCircle = require("components/widgets/LoadingCircle"),
    I18n = require("components/widgets/I18n"),
    FontAwesome = require("components/widgets/FontAwesome"),
    DropDownParseObject = require("components/form/DropDownParseObject"),
    TooltipButton  = require("components/form/TooltipButton"),
    messages = require("i18n/messages");

const TournamentConfigBowSelect = require("components/tournamentregister/TournamentConfigBowSelect"),
    TournamentConfigFinalModal = require("components/tournamentmodal/TournamentConfigFinalModal"),
    TournamentFinalPointModal = require("components/tournamentmodal/TournamentFinalPointModal"),
    TournamentResultEliminationTable = require("components/tournament/TournamentResultEliminationTable"),
    TournamentUserGroupManagerStatus = require("components/tournamentmanage/TournamentUserGroupManagerStatus");

const tournamentUserManagerActions = require("actions/TournamentUserManagerActions"),
    notificationActions = require("components/notification/NotificationActions");

function filterGroups(tUserGroups, selectedBowType) {
    console.log(selectedBowType, tUserGroups);
    if (selectedBowType != null && tUserGroups != null ) {
        return tUserGroups.filter((tUserGroup) => {
            let groupBowType = tUserGroup.getFirstTUserTConfigBow();
            return groupBowType != null && groupBowType.id === selectedBowType.id;
        })
    }
    return [];
}
// Will not be loaded if no final round is available
class TournamentUserGroupFinalPanel extends React.Component {
    constructor(props) {
        super(props);
        this.updateSelRound = this.updateSelRound.bind(this);
        this.updateSelBowType = this.updateSelBowType.bind(this);
        let fRound = this.props.finalRounds[0];
        // find first running round
        for (let i = 0; i < this.props.finalRounds.length; i++) {
            if (this.props.finalRounds[i].isRunning()) {
                fRound = this.props.finalRounds[i];
            }
        }
        this.state = {
            selRound: fRound,
            selectedBowType: null,
            selectedAgeType: this.props.tournament.getTournamentConfigAge()[0],
            filteredTUserGroups: [],
            tUsersResultDic: null,
        }
    }
    componentDidMount() {
        if (this.props.finalRounds.length === 1) {
            // tournamentUserManagerActions.loadTournamentUserGroupsResults.defer(this.props.tournament, this.props.finalRounds[0]);
        }
    }
    updateSelRound(round) {
        let bowType = this.state.selectedBowType;
        const filteredGroups = filterGroups(this.props.tournamentUserStore.tournamentUserGroups, bowType);
        const usersResultDic = tournamentUserManagerActions.filterTUsersForElimination(this.props.tournamentUserStore.tournamentUsers, bowType, round);
        this.setState({selRound: round, filteredTUserGroups:filteredGroups, tUsersResultDic: usersResultDic});
    }
    updateSelBowType(bowType) {
        let round = this.state.selRound;
        const filteredGroups = filterGroups(this.props.tournamentUserStore.tournamentUserGroups, bowType);
        const usersResultDic = tournamentUserManagerActions.filterTUsersForElimination(this.props.tournamentUserStore.tournamentUsers, bowType, round);
        this.setState({selectedBowType: bowType, filteredTUserGroups:filteredGroups, tUsersResultDic: usersResultDic});
    }
    render() {
        const {tournament, tournamentUserStore, finalRounds, user} = this.props;
        const {selRound, selectedBowType, selectedAgeType, filteredTUserGroups, tUsersResultDic} = this.state;
        return <Col xs={12}>
                <Panel>
                    <Panel.Heading>
                        <TopPanelGrpArea tournament={tournament} tournamentUserStore={tournamentUserStore} user={user} finalRounds={finalRounds}
                                         selRound={selRound}  updateSelRound={this.updateSelRound}
                                         selectedBowType={selectedBowType} updateSelBowType={this.updateSelBowType}
                                         tUserGroupAmount={tournamentUserStore.tournamentUserGroups.length} />
                    </Panel.Heading>
                    <Panel.Body>
                         <TopPanelBody tournamentUserGroups={filteredTUserGroups} tUsersResultDic={tUsersResultDic}
                                       selRound={selRound} selectedBowType={selectedBowType} selectedAgeType={selectedAgeType}
                                       tournamentUserStore={tournamentUserStore}/>
                    </Panel.Body>
                </Panel>
            </Col>
    }
}
TournamentUserGroupFinalPanel.propTypes = {
    tournament: PropTypes.object.isRequired,
    tournamentUserStore: PropTypes.object.isRequired,
    finalRounds: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
};
const TopPanelBody = ({selRound, selectedBowType, selectedAgeType, tournamentUserGroups, tUsersResultDic, tournamentUserStore}) => {
    if (!selRound.isFinalElimination()) {
        return <Row><Col xs={12}><Alert bsStyle="warning"><I18n code="tournament.final.noRounds"/></Alert></Col></Row>;
    }
    if (selectedBowType === null) {
        return <Row><Col xs={12}><Alert bsStyle="warning"><I18n code="modal.license.chooseBow"/></Alert></Col></Row>;
    }
    return <React.Fragment>
        <TournamentGroupPanelGrpBody tournamentUserGroups={tournamentUserGroups} eState={selRound.getFinalConfig().eState}
                                     selRound={selRound} selectedBowType={selectedBowType}
                                     groupChangeId={tournamentUserStore.groupChangeId}/>
        <hr/>
        {
            tUsersResultDic != null && selectedAgeType != null && selectedBowType != null ? <React.Fragment>
                {
                    selectedAgeType.hasNoSexSplit() ?
                        <TournamentUserPanelGrpBody groupedTUserList={tUsersResultDic.getList(selectedBowType.id + "zxz" + selectedAgeType.id)} groupChangeId={tournamentUserStore.groupChangeId}/>
                        :
                        <React.Fragment>
                            <TournamentUserPanelGrpBody groupedTUserList={tUsersResultDic.getList(selectedBowType.id + "z0z" + selectedAgeType.id)} groupChangeId={tournamentUserStore.groupChangeId}/>
                            <TournamentUserPanelGrpBody groupedTUserList={tUsersResultDic.getList(selectedBowType.id + "z1z" + selectedAgeType.id)} groupChangeId={tournamentUserStore.groupChangeId}/>
                        </React.Fragment>
                }
            </React.Fragment> : null
        }
    </React.Fragment>
}
const TopPanelGrpArea = ({tournament, user, tournamentUserStore, tUserGroupAmount, finalRounds,
                             selRound, updateSelRound, selectedBowType, updateSelBowType}) => {
    function reloadTUGroups() {
        tournamentUserManagerActions.loadTournamentUserGroups(tournament, true);
        if (selRound != null) {
            updateSelRound(selRound);
        }
    }
    function changeSelectedRound(round) {
        updateSelRound(round);
    }
    return (<React.Fragment>
        <Row>
            <Col xs={3}>
                <h4><strong><I18n code="tournament.live.groups"/></strong></h4>
                {
                    tournamentUserStore.loadingGroup ? <LoadingCircle/> : <p>{"Gruppen: " + tUserGroupAmount}</p>
                }
            </Col>
            <Col xs={3}>
                <DropDownParseObject label={messages.get("tournament.modal.score.tround")}
                                     default={selRound}  onAfterChange={changeSelectedRound}
                                     objectList={finalRounds}/>
                {
                    selRound != null ? <span>
                            <TournamentConfigFinalModal tournament={tournament} tRound={selRound}/>&nbsp;Config: {selRound.getName()}
                        </span> : null
                }
            </Col>
            <Col xs={6}>
                <TournamentConfigBowSelect label={messages.get("tournament.class.bow")} preSelect={false}
                                           disabled={tournamentUserStore.loadingGroup}
                                           defaultValue={selectedBowType ? selectedBowType.id : null}
                                           tournament={tournament} selectCallback={updateSelBowType}/>
            </Col>
        </Row>

        <Row>
            <Col xs={3}>
                <ButtonGroup>
                    <TooltipButton onClick={reloadTUGroups} icon="sync" tooltip={messages.get("tournament.mmtuser.tooltip.group.sync")} />
                </ButtonGroup>
            </Col>
            <Col xs={6}>
                {
                    selRound.getFinalConfig() != null ? <p>State: {selRound.getFinalConfig().eState}</p> : null
                }

            </Col>
        </Row>
    </React.Fragment>)
};
TopPanelGrpArea.propTypes = {
    tournament: PropTypes.object.isRequired,
    tUserGroupAmount: PropTypes.number.isRequired,
    tournamentUserStore: PropTypes.object.isRequired,
    finalRounds:PropTypes.array,
    selRound :PropTypes.object,
    updateSelRound: PropTypes.func.isRequired
};

const TournamentGroupPanelGrpBody = React.memo(
    function TournamentGroupPanelGrpBody({tournamentUserGroups, selectedBowType, selRound, eState, groupChangeId}) {
        // only rerenders if props change
        // groupChangeId -> Used to trigger reRender
        console.log("Render TournamentGroupPanelGrpBody ID: " + groupChangeId) ;
        if (!selRound.isRunning()) {
            return <Row><Col xs={12}><Alert bsStyle="warning"><I18n code="tournament.final.roundNotStarted"/></Alert></Col></Row>
        }
        if (tournamentUserGroups.length === 0 && selectedBowType != null) {
            return <Row><Col xs={12}><Alert bsStyle="warning"><I18n code="tournament.final.noGroups"/></Alert></Col></Row>;
        }
        return  <Row>
            <Col xs={12}>
                <h3><I18n code={"tournament.final.estate." + eState}/></h3>
            </Col>
                    {
                        tournamentUserGroups.map(tUserGroup => {
                            return <TournamentGroupPanelGrpRow key={"TGPGB_" + tUserGroup.id} selRound={selRound} tUserGroup={tUserGroup} />
                        })
                    }
                </Row>
});
TournamentGroupPanelGrpBody.propTypes = {
    tournamentUserGroups: PropTypes.array.isRequired,
    selRound :PropTypes.object,
    groupChangeId: PropTypes.number.isRequired
};
const TournamentUserPanelGrpBody = React.memo(
    function TournamentUserPanelGrpBody({groupedTUserList, groupChangeId}) {
        // only rerenders if props change
        // groupChangeId -> Used to trigger reRender
        console.log("Render TournamentUserPanelGrpBody ID: " + groupChangeId) ;
        let nnGroupedTUserList = groupedTUserList != null ? groupedTUserList : [];
        return <TournamentResultEliminationTable groupedTUserList={nnGroupedTUserList} internalView={true} />
    });
TournamentUserPanelGrpBody.propTypes = {
    groupedTUserList: PropTypes.array.isRequired,
    groupChangeId: PropTypes.number.isRequired
};
const TournamentGroupPanelGrpRow = ({tUserGroup, selRound}) => {
    return <React.Fragment >
                <Col key={"TGPGR_" + tUserGroup.id}  xs={12} md={3}>
                    <TournamentGroupPanel selRound={selRound} tUserGroup={tUserGroup} />
                </Col>

    </React.Fragment>
};
const TournamentGroupPanel = ({selRound, tUserGroup}) => {
    return <ListGroup>
        <ListGroupItem bsStyle={tUserGroup.isDeleted() ? "danger" : "info"}>
            <Row>
                <Col xs={12}>
                    <TournamentUserGroupManagerStatus tournamentUserGroup={tUserGroup} addText={tUserGroup.getName()} />
                </Col>
            </Row>
        </ListGroupItem >
        {
            tUserGroup.getTournamentUserIDs().map(tUser => {
                return <ListGroupItem key={"LGI_" + tUser.id}>
                    {tUser.getFullName()}
                    {
                        <span className="pull-right"><TournamentFinalPointModal tRound={selRound} tUser={tUser} tUserGroup={tUserGroup}/></span>
                    }
                    <br/><br/>
                </ListGroupItem>
            })
        }
    </ListGroup>
};
TournamentGroupPanel.propTypes = {
    tUserGroup: PropTypes.object.isRequired,
    selRound :PropTypes.object,
    groupResults :PropTypes.array
};
module.exports = TournamentUserGroupFinalPanel;
